
import { staticTime } from '@/utils/date';
import Pagination from '@/components/pagination/pagination';
import { serviceRunningStatus, serviceStatusObj } from '@/utils/public';

import moment from 'moment'
let that;
// 单元格的组件
const Editor = {
  template: '<div> {{ text ? text : "-" }} </div>',
  props: ['row', 'col'],
  computed: {
    text() {
      return this.row[this.col.prop];
    },
  },
};
// 运行状态
const runningStatusCom = {
  template: `<div>
  <el-tag v-if="runStatus ===1" type="success">{{ runName ? runName : "-" }}</el-tag>
  <el-tag v-else type="danger">{{ runName ? runName : "-" }}</el-tag>
</div>`,
  props: ['row', 'col'],
  computed: {
    runName() {
      return serviceRunningStatus[this.row.runningStatus];
    },
    runStatus() {
      return this.row.runningStatus;
    },
  },
};

// 查看详情
const detailComponent = {

  template:
      '<div> <el-button type="primary" v-if="packageTime3" @click="checkSign(itemRow)">查看详情</el-button></div>',
    props: ['row', 'col'],
    computed: {
      itemRow() {
        return this.row;
      },
      packageTime3() {
        return this.row?.packageTime === 3
      }
    },
    methods: {
      checkSign(itemRow) {
        console.log(itemRow)
        that.itemRow = itemRow;
        that.dialogVisible = true
        that.getCostLoglist()
        // that.getCostLoglist('101')
        // let base64Url = `data:image/jpg;base64,${stampBase64}`;
        // if (!stampBase64) {
        //   base64Url = defaultBase64Url;
        // }
        // // !stampBase64 && (base64Url = defaultBase64Url);
        // this.$alert(`<img src="${base64Url}" style="width: 400px">`, '签章图片', {
        //   dangerouslyUseHTMLString: true,
        // });
      },
    },

};
// 渠道
const certChannel = {
  template: '<div> {{ text ? text : 0 }} </div>',
  props: ['row', 'col'],
  computed: {
    text() {
      return this.row[this.col.prop] === '1' ? "sdk" : 'app'
      // return this.row[this.col.prop];
    },
  },
};

// 证书状态
const optType = {
  template: '<div> {{ text ? text : 0 }} </div>',
  props: ['row', 'col'],
  computed: {
    text() {
      return this.row[this.col.prop] === 'issue' ? "下载证书" : '更新证书'
      // return this.row[this.col.prop];
    },
  },
};

// 剩余量
const surplusCount = {
  template: '<div> {{ text ? text : 0 }} </div>',
  props: ['row', 'col'],
  computed: {
    text() {
      return this.row[this.col.prop];
    },
  },
};

// 总量
const packageCount = {
  template: '<div> {{ text ? text : 0 }} </div>',
  props: ['row', 'col'],
  computed: {
    text() {
      return this.row[this.col.prop];
    },
  },
};

// 服务状态
const serviceStatusCom = {
  template: `<div>
  <el-tag v-if="serverStatus ===1" type="success">{{ serverName ? serverName : "-" }}</el-tag>
  <el-tag v-else type="danger">{{ serverName ? serverName : "-" }}</el-tag>
</div>`,
  props: ['row', 'col'],
  computed: {
    serverName() {
      return serviceStatusObj[this.row.serviceStatus];
    },
    serverStatus() {
      return this.row.serviceStatus;
    },
  },
};
// 剩余量
// const usedCount = {
//   template: '<div>{{ num }}</div>',
//   props: ['row', 'col'],
//   computed: {
//     num() {
//       return this.row.packageCount - this.row.usedCount;
//     },
//   },
// };
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      dateVal: '',
      formSearchObj1: {
        searchDocSignBean: {
          uniqueId: '',
          archiveUniqueId: '',
          userName: '',
          clientId: this.$store.getters.currentClientId,
          status: '',
          crateStartDate: '',
          createEndDate: '',
        },
        nsid: 101,
        nssid: '',
        pageSize: 10,
        pageNum: 1,
      },
      // 已订阅服务
      formSearchObj: {
        clientId: this.$store.getters.currentClientId,
        startTime: '',
        endTime: '',
        nsid: '',
        runningStatus: '',
        pageSize: 10,
        pageNum: 1,
        uniqueId: '',
        packageName: '',
        status: '',
      },
      runningStatusList: [],
      serviceStatusList: [],
      total: 0,
      tableLoading: false,
      tableData: [],
      columns: [
        { label: '订单编号', prop: 'orderNum' },
        { label: '已订阅服务名称', prop: 'serviceName' },
        { label: '总额', prop: 'packageCount', component: packageCount },
        { label: '剩余', prop: 'surplusCount', component: surplusCount },
        {
          label: '运行状态',
          prop: 'runningStatus',
          component: runningStatusCom,
        },
        {
          label: '服务状态',
          prop: 'serviceStatus',
          component: serviceStatusCom,
        },
        { label: '启用时间', prop: 'effectiveStartTime' },
        { label: '到期时间', prop: 'endTime' },
        { label: '操作', prop: 'endTime', component: detailComponent },
      ],
      columnsProps: {
        align: 'center',
        // sortable: true
        // 定义表格列如何渲染
        component: Editor,
      },
      // tarchiveList: [],
      serviceSignStatusList: [],
      itemRow: {},
      costLoglist:[],
      dialogVisible: false,
      costLoglistColumns:[
        { label: '医师姓名', prop: 'doctorName' },
        { label: '渠道', prop: 'certChannel', component: certChannel },
        { label: '获取时间', prop: 'createTime' },
        { label: '获取方式', prop: 'optType', component: optType },
      ],
      // 服务流水
      formCostLog: {
        // startTime: '',
        // endTime: '',
        // nsid: '',
        // runningStatus: '',
        // uniqueId: '',
        // packageName: '',
        // status: '',
        pageSize: 10,
        pageNum: 1,
        total: 0,
      },
    };
  },
  created() {
    that = this;
    // this.getArchiveList();
    Object.getOwnPropertyNames(serviceRunningStatus).forEach((key) => {
      const item = {
        key,
        value: serviceRunningStatus[key],
      };
      this.runningStatusList.push(item);
    });
    Object.getOwnPropertyNames(serviceStatusObj).forEach((key) => {
      const item = {
        key,
        value: serviceStatusObj[key],
      };
      this.serviceStatusList.push(item);
    });

    this.getTableData();
  },
  methods: {
    // 获取归档范围下拉列表数据
    // getArchiveList() {
    //   const that = this;
    //   that.$API
    //     .getarchivelist()
    //     .then((result) => {
    //       if (!that.$API.ApiRequest(result)) {
    //         return;
    //       }
    //       that.tarchiveList = result.data;
    //     })
    //     .catch();
    // },
    getTableData1() {
      this.tableLoading = true;
      this.$API
        .searchServiceDetail(this.formSearchObj)
        .then((result) => {
          //   this.tableLoading = false;
          if (!this.$API.ApiRequest(result)) {
            return;
          }
          this.tableData = result.data.list;
          this.total = result.data.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    getTableData() {
      this.tableLoading = true;
      this.$API
        .querySubService(this.formSearchObj)
        .then((result) => {
          if (!this.$API.ApiRequest(result)) {
            this.cmListData = [];
            return;
          }
          this.tableData = result.data.list;
          this.total = result.data.total;
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    onSearch() {
      this.formSearchObj.pageNum = 1;
      this.getTableData();
    },
    changeStatusSearch() {
      this.getTableData();
    },
    sizeChange(num) {
      this.formSearchObj.pageSize = num;
      this.formSearchObj.pageNum = 1;
      this.getTableData();
    },
    currentChange(num) {
      this.formSearchObj.pageNum = num;
      this.getTableData();
    },
    changeDate() {
      const dateArr = staticTime(this.dateVal);
      // eslint-disable-next-line prefer-destructuring
      this.formSearchObj.startTime = dateArr[0];
      this.formSearchObj.endTime = dateArr[1];
      this.getTableData();
    },
   
    // 获取服务包流水
    getCostLoglist() {
      // const { clientId } = this.$cookies.get('userLoginInfo');
      this.$API
        .costLoglistByAgent({
          nSSId: this.itemRow.nSSId,
          clientIds: [this.formSearchObj.clientId],
          pageNum: this.formCostLog.pageNum,
          pageSize: this.formCostLog.pageSize
        })
        .then((result) => {
          if (!this.$API.ApiRequest(result)) {
            this.cmListData = [];
            return;
          }
          console.log(result)
          this.costLoglist = result.data.list;
          this.formCostLog.total = result.data.total;
        })
    },

    costLogSizeChange(num) {
      this.formCostLog.pageSize = num;
      this.formCostLog.pageNum = 1;
      this.getCostLoglist();
    },
    costLogCurrentChange(num) {
      this.formCostLog.pageNum = num;
      this.getCostLoglist();
    },
    exportTable() {
      // const { clientId } = this.$cookies.get('userLoginInfo');
      const params = {
        // doctorName: this.formData.form.applicantName,
        // optType: this.formData.form.optType,
        // certChannel: this.formData.form.certChannel,
        // nSId: this.detailParams.nSId,
        nSSId: this.itemRow.nSSId,
        clientIds: [this.formSearchObj.clientId],
      }
      this.$API.exportCostLogByAgent(params).then((response) => {
        const blob = response
        const a = document.createElement('a')
        const url = window.URL.createObjectURL(blob)
        a.href = url
        // 设置文件名称
        a.download = `订阅服务凭证包流水列表${moment().format(
          'YYYY-MM-DD'
        )}.xls`
        a.click()
      })
    }
  },
};
